import { render, staticRenderFns } from "./ManageRentalClubs.vue?vue&type=template&id=db110764"
import script from "./ManageRentalClubs.vue?vue&type=script&lang=ts"
export * from "./ManageRentalClubs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports